import clsx from 'clsx';
import React from 'react';

const CpcIcon = (props: { size: string; offsetUp?: boolean; className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    height={props.size}
    width={props.size}
    className={clsx('tw-relative', props.offsetUp ? '-tw-top-[0.09em]' : null, props.className)}
  >
    <path
      fill="currentColor"
      d="M64 40c-13.3 0-24 10.7-24 24l0 384c0 13.3 10.7 24 24 24l320 0c13.3 0 24-10.7 24-24l0-384c0-13.3-10.7-24-24-24L64 40zM0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm112 64l224 0c11 0 20 9 20 20s-9 20-20 20L112 168c-11 0-20-9-20-20s9-20 20-20zm0 96l224 0c11 0 20 9 20 20s-9 20-20 20L112 264c-11 0-20-9-20-20s9-20 20-20zm0 96l112 0c11 0 20 9 20 20s-9 20-20 20L112 360c-11 0-20-9-20-20s9-20 20-20z"
    />
  </svg>
);

export default CpcIcon;
